import { REGULAR_TIER, UNLIMITED_TIER } from "@chesshotel/constants";
import { useMembership } from "../../redux/membership";

export default function PlayWire({ className, id }) {
  const { tier } = useMembership();

  if (tier === REGULAR_TIER || tier === UNLIMITED_TIER) {
    return null;
  }

  return (
    // <div className={`flex flex-col justify-center items-center ${contStyles}`}>
    <div id={id} className={className}></div>
    // </div>
  );
}
